/**
 * @generated SignedSource<<ec8b8771c872e1973d243f6a7b0cb62a>>
 * @relayHash 1c39b72e16854d19d11c51ceef0122b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434

import type { ConcreteRequest } from 'relay-runtime';
export type fetchMentionsProviderDataQuery$variables = Record<PropertyKey, never>;
export type fetchMentionsProviderDataQuery$data = {
  readonly entitlements: {
    readonly externalCollaborator: {
      readonly isEntitled: boolean;
    };
  } | null | undefined;
};
export type fetchMentionsProviderDataQuery = {
  response: fetchMentionsProviderDataQuery$data;
  variables: fetchMentionsProviderDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "Entitlements",
    "kind": "LinkedField",
    "name": "entitlements",
    "plural": false,
    "selections": [
      {
        "concreteType": "ExternalCollaboratorFeature",
        "kind": "LinkedField",
        "name": "externalCollaborator",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEntitled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "fetchMentionsProviderDataQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "fetchMentionsProviderDataQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1c39b72e16854d19d11c51ceef0122b1",
    "id": "57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434",
    "metadata": {},
    "name": "fetchMentionsProviderDataQuery",
    "operationKind": "query",
    "text": "query fetchMentionsProviderDataQuery{entitlements{externalCollaborator{isEntitled}}}"
  }
};
})();

(node as any).hash = "97f5ab279ca8162d7d39b760a9aa8808";

export default node;
